<div *ngIf="show" class="fixed inset-0 z-50 flex items-center justify-center p-4 modal-overlay" (click)="onClose()">
  <div class="modal-container max-w-lg w-full rounded-2xl relative" (click)="$event.stopPropagation()">
    <!-- Header Area -->
    <div class="modal-header">
      <div class="absolute top-4 right-4">
        <button type="button" class="close-btn" (click)="onClose()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div class="relative z-10">
        <h2 class="mode-title">
          {{ mode === 'LOGIN' ? 'Welcome Back' : 'Join ISA Indore' }}
        </h2>
        <p class="mode-subtitle">
          {{ mode === 'LOGIN' ? 'Sign in to access your member dashboard' : 'Apply for INDOTECH SOFTWARE ASSOCIATION Membership' }}
        </p>
      </div>
    </div>

    <!-- Content Area -->
    <div class="p-8 custom-scrollbar max-h-[70vh] overflow-y-auto">

      <!-- Plan Selection Step (Registration) -->
      <ng-container *ngIf="mode === 'REGISTER' && step === 'PLAN_SELECTION'">
        <div class="mb-8 p-4 bg-blue-50 border border-blue-100 rounded-xl text-center">
            <h3 class="text-lg font-black text-blue-900 mb-2">Final Step: Select Membership Plan</h3>
            <p class="text-xs font-bold text-blue-700">Your application details are saved. Choose a plan and complete payment to submit to admin.</p>
        </div>

        <div *ngIf="isLoading" class="py-12 text-center text-slate-400 font-bold uppercase tracking-widest text-[10px]">
           <div class="h-8 w-8 border-4 border-slate-100 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
           Synchronizing Membership Tiers...
        </div>

        <div *ngIf="!isLoading && plans.length > 0" class="space-y-4">
           <div *ngFor="let plan of plans" (click)="selectPlan(plan)" class="p-5 border-2 rounded-[24px] cursor-pointer transition-all hover:scale-[1.02] active:scale-[0.98]" 
                [ngClass]="plan.price === 0 ? 'bg-white border-slate-100 hover:border-emerald-400' : 'bg-slate-900 border-slate-800 hover:border-indigo-500 shadow-xl'">
              <div class="flex justify-between items-start mb-4">
                  <div>
                      <h4 class="text-base font-black tracking-tight" [class.text-white]="plan.price > 0">{{ plan.name }}</h4>
                      <span class="text-[9px] font-black uppercase tracking-widest px-2 py-1 rounded-full" 
                            [ngClass]="plan.price === 0 ? 'bg-emerald-50 text-emerald-600' : 'bg-white/10 text-white/60'">
                        {{ plan.price === 0 ? 'Free Entry' : 'Premium Tier' }}
                      </span>
                  </div>
                  <div class="text-right">
                      <p class="text-xl font-black tracking-tighter" [class.text-white]="plan.price > 0">₹ {{ plan.price.toLocaleString('en-IN') }}</p>
                      <p class="text-[9px] font-bold uppercase" 
                         [ngClass]="{'text-white/40': plan.price > 0, 'text-slate-400': plan.price === 0}">
                        / {{ plan.durationMonths }} MON
                      </p>
                  </div>
              </div>
              <ul class="space-y-2 mb-4">
                  <li *ngFor="let f of (plan.features || []).slice(0, 3)" 
                      class="flex items-center gap-2 text-[11px] font-bold" 
                      [ngClass]="{'text-white/70': plan.price > 0, 'text-slate-600': plan.price === 0}">
                    <span class="text-indigo-500">◈</span> {{ getFeatureLabel(f) }}
                  </li>
              </ul>
              <div class="flex justify-center pt-2">
                 <span class="text-[10px] font-black uppercase tracking-widest" [class.text-white]="plan.price > 0" [class.text-indigo-600]="plan.price === 0">Select and Continue →</span>
              </div>
           </div>
        </div>

        <div class="mt-8 text-center pt-6 border-t border-slate-50">
           <p class="text-xs text-slate-400 font-bold">ALREADY HAVE ACCOUNT? <button (click)="mode = 'LOGIN'" class="text-indigo-600 border-b-2 border-indigo-100 ml-1">SIGN IN INSTEAD</button></p>
        </div>
      </ng-container>

      <!-- Error/Success Messages -->
      <div class="error-message flex items-center gap-3" *ngIf="errorMessage && (mode === 'LOGIN' || mode === 'REGISTER')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>{{ errorMessage }}</span>
      </div>

      <div class="success-message flex items-center gap-3" *ngIf="successMessage && (mode === 'LOGIN' || mode === 'REGISTER')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        <span>{{ successMessage }}</span>
      </div>

      <!-- Login Form (Original) -->
      <ng-container *ngIf="mode === 'LOGIN'">
        <div class="form-group">
          <label class="form-label">Email Address</label>
          <div class="input-container">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <input type="email" [(ngModel)]="loginEmail" class="form-input" placeholder="name@company.com">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Password</label>
          <div class="input-container">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <input type="password" [(ngModel)]="loginPassword" class="form-input" placeholder="••••••••">
          </div>
        </div>
      </ng-container>

      <!-- Registration Form (Updated with Go Back option) -->
      <ng-container *ngIf="mode === 'REGISTER' && step === 'AUTH_FORM'">
        <div class="mb-6">
          <h3 class="text-xl font-black text-slate-900 mb-1">Company Information</h3>
          <p class="text-xs font-bold text-slate-400 uppercase tracking-widest">Complete your INDOTECH SOFTWARE ASSOCIATION application</p>
        </div>

        <div class="register-grid">
          <div class="form-group">
            <label class="form-label">Company Name <span class="text-red-500">*</span></label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="10" width="20" height="12" rx="2"></rect>
                <path d="M7 10V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v5"></path>
              </svg>
              <input [(ngModel)]="regData.company" type="text" class="form-input" placeholder="Tech Solutions Ltd">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Website</label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                </path>
              </svg>
              <input [(ngModel)]="regData.website" type="text" class="form-input" placeholder="www.example.com">
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Director Name(s) <span class="text-red-500">*</span></label>
          <div class="input-container">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <input [(ngModel)]="regData.applicantName" type="text" placeholder="Full name of directors"
              class="form-input">
          </div>
        </div>

        <div class="register-grid">
          <div class="form-group">
            <label class="form-label">Email (Official) <span class="text-red-500">*</span></label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <input [(ngModel)]="regData.email" type="email" class="form-input" placeholder="admin@company.com">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Phone Number <span class="text-red-500">*</span></label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                </path>
              </svg>
              <input [(ngModel)]="regData.phone" type="text" class="form-input" placeholder="+91 00000 00000">
            </div>
          </div>
        </div>

        <div class="register-grid">
          <div class="form-group">
            <label class="form-label">Team Size <span class="text-red-500">*</span></label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <select [(ngModel)]="regData.teamSize"
                class="form-input pl-[2.75rem] appearance-none bg-no-repeat bg-[right_1rem_center] bg-[length:1em_1em]">
                <option value="" disabled selected>Select Size</option>
                <option value="1-10">1-10 Employees</option>
                <option value="11-50">11-50 Employees</option>
                <option value="51-200">51-200 Employees</option>
                <option value="200+">200+ Employees</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Domain/Industry <span class="text-red-500">*</span></label>
            <div class="input-container">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 21h18"></path>
                <path d="M3 7v14"></path>
                <path d="M13 21V3H3"></path>
                <path d="M7 14h2"></path>
                <path d="M7 18h2"></path>
                <path d="M7 6h2"></path>
                <path d="M7 10h2"></path>
                <path d="M13 6h2"></path>
                <path d="M13 10h2"></path>
                <path d="M13 14h2"></path>
                <path d="M13 18h2"></path>
              </svg>
              <select [(ngModel)]="regData.industry" class="form-input pl-[2.75rem] appearance-none">
                <option value="" disabled selected>Select Industry</option>
                <option value="SaaS">SaaS</option>
                <option value="Fintech">Fintech</option>
                <option value="Services">Services</option>
                <option value="HealthTech">HealthTech</option>
                <option value="EdTech">EdTech</option>
                <option value="AI">AI</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Technology Stack</label>
          <div class="input-container">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="16 18 22 12 16 6"></polyline>
              <polyline points="8 6 2 12 8 18"></polyline>
            </svg>
            <input [(ngModel)]="regData.techStack" type="text" placeholder="e.g. Java, Angular, AWS" class="form-input">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Office Address <span class="text-red-500">*</span></label>
          <div class="input-container items-start">
            <svg class="input-icon mt-3" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            <textarea [(ngModel)]="regData.address" rows="2" class="form-input min-h-[80px]"
              placeholder="Complete registered office address"></textarea>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Create Password <span class="text-red-500">*</span></label>
          <div class="input-container">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <input [(ngModel)]="regData.password" type="password" class="form-input"
              placeholder="Create a strong password">
          </div>
        </div>
      </ng-container>

      <!-- Actions -->
      <div class="mt-8 space-y-4" *ngIf="mode === 'LOGIN' || step === 'AUTH_FORM'">
        <button (click)="handleAuth()" class="btn-primary" [disabled]="isLoading">
          <span *ngIf="!isLoading">
            {{ mode === 'LOGIN' ? 'Sign In' : 'Submit Membership Application' }}
          </span>
          <span *ngIf="isLoading" class="flex items-center gap-2">
            <svg class="animate-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="2" x2="12" y2="6"></line>
              <line x1="12" y1="18" x2="12" y2="22"></line>
              <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
              <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
              <line x1="2" y1="12" x2="6" y2="12"></line>
              <line x1="18" y1="12" x2="22" y2="12"></line>
              <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
              <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
            </svg>
            {{ mode === 'LOGIN' ? 'Verifying...' : 'Processing...' }}
          </span>
        </button>

        <div *ngIf="mode === 'LOGIN'" class="text-center">
          <div class="flex items-center gap-4 my-4">
            <div class="h-px flex-1 bg-gray-200"></div>
            <span class="text-xs text-gray-400 font-bold uppercase tracking-wider">New to ISA?</span>
            <div class="h-px flex-1 bg-gray-200"></div>
          </div>
          <button type="button" (click)="switchToJoinIsa()" class="btn-outline">
            Join INDOTECH SOFTWARE ASSOCIATION
          </button>
        </div>

        <div *ngIf="mode === 'REGISTER'" class="text-center">
          <p class="text-sm text-gray-500">
            Already a member?
            <button (click)="mode = 'LOGIN'" class="text-blue-600 font-bold hover:underline">Sign In</button>
          </p>
        </div>
      </div>

    </div>
  </div>
</div>